export interface DocumentTypeProps {
    id: number;
    typeName: string;
    typeKey: string;
  }
  
  export class DocumentType {
    private readonly _id: number;
    private readonly _typeName: string;
    private readonly _typeKey: string;
  
    constructor(props: DocumentTypeProps) {
      this._id = props.id;
      this._typeName = props.typeName;
      this._typeKey = props.typeKey;
    }
  
    public get id(): number {
      return this._id;
    }
  
    public get typeName(): string {
      return this._typeName;
    }
  
    public get typeKey(): string {
      return this._typeKey;
    }
  
    public static fromJson(json: DocumentTypeProps): DocumentType {
      return new DocumentType({
        id: json.id,
        typeName: json.typeName,
        typeKey: json.typeKey,
      });
    }
  }
  